import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            As a <span className="purple">Senior Tech Consultant</span> at IzzkiTech Solutions,
            I specialize in designing and implementing enterprise-scale solutions.
            <br /><br />
            My expertise spans full-stack development, cloud architecture, and AI integration.
            I focus on delivering scalable, maintainable systems that solve complex business challenges.
            <br /><br />
            Notable achievements include leading the development of open-source projects like
            Astroluma (700+ GitHub stars) and creating innovative solutions for enterprise clients.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Open Source Contributions
            </li>
            <li className="about-activity">
              <ImPointRight /> AI/ML Research
            </li>
          </ul>

          <div className="contact-buttons" style={{ marginTop: "20px" }}>
            <a
              href="https://github.com/Sanjeet990"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button"
              aria-label="GitHub Profile"
            >
              <FaGithub /> Github
            </a>
            <a
              href="https://www.linkedin.com/in/sanjeet-pathak/"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button"
              aria-label="LinkedIn Profile"
            >
              <FaLinkedin /> LinkedIn
            </a>
            <a
              href="https://www.reddit.com/r/Astroluma/"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button"
              aria-label="Reddit Community"
            >
              <i className="fab fa-reddit"></i> Reddit
            </a>
            <a 
              href="mailto:hello@sanjeetpathak.com" 
              className="contact-button special"
              aria-label="Contact Me"
            >
              <MdEmail /> Contact Me
            </a>
          </div>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
